import React, { FC } from "react";
import {
  Card, CardContent, CardHeader, Container, Divider, Grid, Paper
} from "@mui/material";
import { useTranslation } from "react-i18next";
import store from "./store";
import { observer } from "mobx-react";
import CustomTextField from "components/TextField";
import CustomCheckbox from "components/Checkbox";

type DepartmentBaseProps = {
  children?: React.ReactNode;
  isPopup?: boolean;
};

const DepartmentAddEditBaseView: FC<DepartmentBaseProps> = observer((props) => {
  const { t } = useTranslation();

  return (
    <Container maxWidth='xl' sx={{ mt: props.isPopup ? 0 : 3, px: props.isPopup ? 0 : undefined }}>
      <Grid container spacing={3}>
        <Grid item md={props.isPopup ? 12 : 6} xs={12}>
          <form autoComplete='off'>
            <Card component={Paper} elevation={props.isPopup ? 0 : 5}>
              {!props.isPopup && (
                <>
                  <CardHeader title="Отдел" />
                  <Divider />
                </>
              )}
              <CardContent>
                <Grid container spacing={3}>
                  <Grid item md={12} xs={12}>
                    <CustomTextField
                      value={store.name}
                      onChange={(e) => store.handleChange(e)}
                      name="name"
                      id="id_f_department_name"
                      label="Название"
                      helperText={store.errors.name}
                      error={!!store.errors.name}
                    />
                  </Grid>
                  <Grid item md={12} xs={12}>
                    <CustomTextField
                      value={store.description}
                      onChange={(e) => store.handleChange(e)}
                      name="description"
                      id="id_f_department_description"
                      label="Описание"
                      multiline
                      rows={3}
                    />
                  </Grid>
                  <Grid item md={6} xs={12}>
                    <CustomCheckbox
                      value={store.is_active}
                      onChange={(e) => store.handleChange(e)}
                      name="is_active"
                      label="Активен"
                      id="id_f_department_is_active"
                    />
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </form>
        </Grid>
        {props.children}
      </Grid>
    </Container>
  );
});

export default DepartmentAddEditBaseView;
